module.exports = __webpack_public_path__ + "img/tour-63.180eae1b.png";